
import * as React from "react";
import {Api} from "../../../../lib/Api";

interface IReviewButtonProps {
    order: any
    setUrl: any

}

interface IReviewButtonState {
}

export default class ReviewButton extends React.Component<IReviewButtonProps, IReviewButtonState>{

    constructor(props:IReviewButtonProps){
        super(props);
        this.state = {

        };

    }



    render() {

       let order = this.props.order;

        if(order.status.key != 'completed'){
            return (<></>);
        }

        return (
            <div className = "row">
                <div className = "col-md-12">
                    <button className="green_btn" onClick={() => this.props.setUrl('/order/review', { order: order})}>Add review</button>
                </div>
            </div>
        );


    }
}
